import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import dayjs from "dayjs";
import "dayjs/locale/it";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";

import {
  TextField,
  MenuItem,
  Button,
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Grid,
  TextareaAutosize,
  Autocomplete,
} from "@mui/material";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { selectTerreni } from "../../../features/terreni/terreniSlice";
import {
  createTrattamenti,
  fetchTrattamenti,
  updateTrattamenti,
} from "../../../features/trattamenti/trattamentiThunk";
import { selectparticelle } from "../../../features/particelle/particelleSlice";
import { selectOperatori } from "../../../features/operatori/operatoriSlice";
import { fetchOperatori } from "../../../features/operatori/operatoriThunk";
import { fetchTerreni } from "../../../features/terreni/terreniThunk";
import { fetchParticelle } from "../../../features/particelle/particelleThunk";
const Textarea = styled(TextareaAutosize)`
  box-sizing: border-box;
  width: 100%;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 12px;
  border-radius: 5px;
  color: #160a2a;
  background: #fff;
  border: 2px solid #e5e5e5;
`;

// Updated EmptyTextarea Component
const EmptyTextarea = ({ placeholder, value, onChange }) => {
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  const handleChange = (event) => {
    setInputValue(event.target.value);
    onChange(event);
  };

  return (
    <Textarea
      aria-label="empty textarea"
      placeholder={placeholder}
      minRows={4}
      value={inputValue}
      onChange={handleChange}
    />
  );
};

const schema = yup.object().shape({
  // nomeProduzione: yup.string().required("Nome della Produzione è obbligatorio"),
  idParticella: yup.mixed().required("ID Particella è obbligatorio"),
  terreno_id: yup.mixed(),
  tipoTrattamento: yup.string().required("Tipo di trattamento è obbligatorio"),
  data: yup
    .date()
    .required("La data è obbligatoria")
    .typeError("Data non valida"),
  prodottoUtilizzato: yup
    .string()
    .required("Prodotto utilizzato è obbligatorio"),
  quantitaProdotto: yup
    .number()
    .typeError("La quantità deve essere un numero")
    .positive("La quantità deve essere positiva")
    .required("Quantità prodotto è obbligatoria"),
  modalitaApplicazione: yup
    .string()
    .required("Modalità di applicazione è obbligatoria"),
  operatoreResponsabile: yup
    .mixed()
    .required("Operatore responsabile è obbligatorio"),
  intervalloSicurezza: yup
    .string()
    .required("Intervallo di sicurezza è obbligatorio"),
});
const options = ["Amministratore", "Collaboratore", "Operatore"];

dayjs.locale("it");

const TrattamentiForm = ({ cantine, setCantine, singleData }) => {
  const intervalloSicurezzaData = useSelector(
    (store) => store.trattamenti.siccurezza
  );
  const modalitaApplicazioneData = useSelector(
    (store) => store.trattamenti.appicazione
  );
  const trattamentoApplicazioneData = useSelector(
    (store) => store.trattamenti.trattamento
  );
  const isOpenTrattamentiTerni = localStorage.getItem("trattamenti");
  const terreniId = useSelector(selectTerreni);
  const operatri = useSelector(selectOperatori);
  const operatriId = operatri?.filter(op => op.role_id === "OPERATOR")
  
  const partiCellaId = useSelector(selectparticelle);
  const ids = terreniId.map((item) => item.nome);
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  useEffect(()=>{
    dispatch(fetchTerreni())
    dispatch(fetchParticelle())
    dispatch(fetchOperatori())
  },[dispatch])

  useEffect(() => {
    dispatch(fetchOperatori())
    if (isOpenTrattamentiTerni) {
      const terrenoObject =
        terreniId.find((t) => t.id === singleData?.terreno_id) || null;
      const particellaObject =
        partiCellaId.find((p) => p.id === singleData?.particella_id) || null;
        const operatriObject =
        operatriId.find((t) => t.id === singleData?.operatore_id) || null;
      setValue("idParticella", particellaObject);
      setValue("terreno_id", terrenoObject);
      setValue("nomeProduzione", singleData?.tra_name || null);
      setValue("idLotto", singleData?.lotto_id || null);
      setValue("tipoTrattamento", singleData?.tipo_di_trattamento || null);
      setValue(
        "data",
        singleData?.data_trattamento
          ? dayjs(singleData?.data_trattamento)
          : null
      );
      setValue("quantitaProdotto", singleData?.qty || null);
      setValue("prodottoUtilizzato", singleData?.prodotto_utilizzato || null);
      setValue("modalitaApplicazione", singleData?.applicazione || null);
      setValue(
        "operatoreResponsabile",
        operatriObject
      );
      setValue("intervalloSicurezza", singleData?.intervallo_sicurezza || null);
      setValue("note", singleData?.note || null);
    }
  }, [singleData, setValue,dispatch]);

  const onSubmit = async (data) => {
    let payload = {
      particella_id: data.idParticella?.id,
      terreno_id: data.terreno_id?.id,
      tra_name: data.nomeProduzione,
      produzione_id: data.idLotto,
      lotto_id: data.idLotto,
      tipo_di_trattamento: data.tipoTrattamento,
      data_trattamento: data.data
        ? dayjs(data.data).format("YYYY-MM-DD")
        : null,
      qty: data.quantitaProdotto,
      prodotto_utilizzato: data.prodottoUtilizzato,
      applicazione: data.modalitaApplicazione,
      operatore_id: data.operatoreResponsabile?.id,
      intervallo_sicurezza: data.intervalloSicurezza,
      note: data.note,
    };
    const res = !isOpenTrattamentiTerni
      ? await dispatch(createTrattamenti(payload))
      : await dispatch(
          updateTrattamenti({ id: singleData?.id, data: payload })
        ).unwrap();

    if (res.success || res.payload.success) {
      dispatch(fetchTrattamenti());
      setCantine(false);
      localStorage.removeItem("trattamenti");
    }
  };

  return (
    <>
      <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
        <div className="AziendaFrom__inner">
          {/* <Controller
                        defaultValue=""
                        name="nomeProduzione"
                        control={control}
                        render={({ field }) => (
                            <TextField className="customTextBox"
                                {...field}
                                value={field.value || ""}
                                label="Nome trattamento"
                                fullWidth
                                margin="normal"
                                error={!!errors.nomeProduzione}
                                helperText={errors.nomeProduzione?.message}
                            />
                        )}
                    /> */}

          {/* <Controller
                        defaultValue=""
                        name="idParticella"
                        control={control}
                        render={({ field }) => (
                            <TextField className="customTextBox"
                                {...field}
                                value={field.value || ""}
                                label="ID Particella"
                                fullWidth
                                margin="normal"
                                error={!!errors.idParticella}
                                helperText={errors.idParticella?.message}
                            />
                        )}
                    /> */}
          <Controller
            defaultValue=""
            name="idParticella"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={partiCellaId}
                getOptionLabel={(option) => option.id || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                value={field.value || null}
                onChange={(event, value) => field.onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="ID Particella"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.terreno_id}
                    helperText={errors.terreno_id?.message}
                  />
                )}
              />
            )}
          />

          <Controller
            defaultValue=""
            name="terreno_id"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={terreniId}
                getOptionLabel={(option) => option.nome || ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={field.value || null}
                onChange={(event, value) => field.onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="ID Terreno"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.terreno_id}
                    helperText={errors.terreno_id?.message}
                  />
                )}
              />
            )}
          />

          {/* <Controller
                        defaultValue=""
                        name="idLotto"
                        control={control}
                        render={({ field }) => (
                            <TextField className="customTextBox"
                                {...field}
                                value={field.value || ""}
                                label="ID Lotto"
                                fullWidth
                                margin="normal"
                                error={!!errors.idLotto}
                                helperText={errors.idLotto?.message}
                            />
                        )}
                    /> */}

          <Controller
            defaultValue=""
            name="tipoTrattamento"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={trattamentoApplicazioneData}
                value={field.value || null}
                onChange={(event, value) => setValue("tipoTrattamento", value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo dI Trattamento"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.tipoTrattamento}
                    helperText={errors.tipoTrattamento?.message}
                  />
                )}
              />
            )}
          />

          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
            <Controller
              defaultValue=""
              name="data"
              control={control}
              render={({ field }) => (
                <DatePicker
                  className="datePickerField"
                  label="Data"
                  value={field.value || null}
                  onChange={(newValue) => setValue("data", newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={!!errors.data}
                      helperText={errors.data?.message}
                      fullWidth
                      margin="normal"
                    />
                  )}
                />
              )}
            />
          </LocalizationProvider>

          <Controller
            defaultValue=""
            name="prodottoUtilizzato"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                value={field.value || ""}
                label="Prodotto Utilizzato"
                fullWidth
                margin="normal"
                error={!!errors.prodottoUtilizzato}
                helperText={errors.prodottoUtilizzato?.message}
              />
            )}
          />
          <Controller
            defaultValue=""
            name="quantitaProdotto"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                value={field.value || ""}
                label="Q.ta prodotto"
                fullWidth
                margin="normal"
                error={!!errors.quantitaProdotto}
                helperText={errors.quantitaProdotto?.message}
              />
            )}
          />

          <Controller
            defaultValue=""
            name="modalitaApplicazione"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={modalitaApplicazioneData}
                value={field.value || null}
                onChange={(event, value) =>
                  setValue("modalitaApplicazione", value)
                } // To handle selected value properly
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Modalità di applicazione"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.modalitaApplicazione}
                    helperText={errors.modalitaApplicazione?.message}
                  />
                )}
              />
            )}
          />

          <Controller
            defaultValue=""
            name="operatoreResponsabile"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={operatriId}
                getOptionLabel={(option) => option.name || ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={field.value || null}
                onChange={(event, value) => field.onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Operatore Responsabile"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.terreno_id}
                    helperText={errors.terreno_id?.message}
                  />
                )}
              />
            )}
          />
          {/* 
                    <Controller
                        defaultValue=""
                        name="operatoreResponsabile"
                        control={control}
                        render={({ field }) => (
                            <TextField className="customTextBox"
                                {...field}
                                value={field.value || ""}
                                label="Operatore Responsabile"
                                fullWidth
                                margin="normal"
                                error={!!errors.operatoreResponsabile}
                                helperText={errors.operatoreResponsabile?.message}
                            />
                        )}
                    /> */}

          <Controller
            defaultValue=""
            name="intervalloSicurezza"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={intervalloSicurezzaData}
                value={field.value || null}
                onChange={(event, value) =>
                  setValue("intervalloSicurezza", value)
                } // To handle selected value properly
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Intervallo di sicurezza"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.intervalloSicurezza}
                    helperText={errors.intervalloSicurezza?.message}
                  />
                )}
              />
            )}
          />

          <Controller
            defaultValue=""
            name="note"
            control={control}
            render={({ field }) => (
              <EmptyTextarea placeholder="Note" {...field} />
            )}
          />

          <div className="btnPart1">
            <Button type="submit" variant="contained">
              Salva dati
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};

export default TrattamentiForm;
